import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { NextSeo } from 'next-seo';
import { MainLayout } from '@/components/layout/main-layout';
import { Banner } from '@/components/banner';
import { useTranslation } from 'next-i18next';
import { demoConfig } from './demo.config';
import { sayHello } from '@your-org/core-lib';
import { InfoCard } from '@your-org/ui-lib/component/info-card';
import { AsyncMessage, Message } from '@your-org/ui-lib';
import Image from 'next/image';
import { DemoApiSection } from './sections/demo-api.section';
export var DemoPage = function DemoPage() {
  var _useTranslation = useTranslation(demoConfig.i18nNamespaces),
      t = _useTranslation.t;

  return _jsxs(_Fragment, {
    children: [_jsx(NextSeo, {
      title: t('home:page.title'),
      description: "Web-app nextjs monorepo example, https://github.com/belgattitude/nextjs-monorepo-example"
    }), _jsxs(MainLayout, {
      children: [_jsx(Banner, {}), _jsx("h3", {
        children: "I'm the web-app"
      }), _jsxs("ul", {
        children: [_jsx(InfoCard, {
          originatingAppName: 'web-app'
        }), _jsx("li", {
          children: "Foo says: ".concat(sayHello('World'), " from @your-org/core-lib")
        }), _jsx("li", {
          children: _jsx(Message, {
            message: 'Bar react component from @your-org/ui-lib'
          })
        }), _jsx("li", {
          children: _jsx(AsyncMessage, {
            apiUrl: '/api/hello'
          })
        })]
      }), _jsx(Image, {
        src: '/shared-assets/images/nextjs-logo.png',
        alt: 'logo',
        width: 400,
        height: 240
      }), _jsx(DemoApiSection, {})]
    })]
  });
};